// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3tdXF","productName":"Table_productName__1eAQ2"};